import { api } from '@api/api2';
import {
  GetIncidentsRelatedListPayload,
  GetRelatedAvailablePayload,
  RelatedCheckPayload,
  RelatedDeletePayload,
  RelatedSavePayload,
} from './types';

const getList = (payload: GetIncidentsRelatedListPayload) =>
  api.v1('get', 'tck/bms/incidents/related/list', payload);

const getRelatedAvailable = (payload: GetRelatedAvailablePayload) =>
  api.v1('get', 'tck/bms/incidents/related/available', payload);

const relatedCheck = (payload: RelatedCheckPayload) =>
  api.v1('post', 'tck/bms/incidents/related/check', payload, {
    headers: { 'Content-Type': 'application/json' },
  });

const relatedSave = (payload: RelatedSavePayload) =>
  api.v1('post', 'tck/bms/incidents/related/save', payload, {
    headers: { 'Content-Type': 'application/json' },
  });

const relatedDelete = (payload: RelatedDeletePayload) =>
  api.v1('post', 'tck/bms/incidents/related/delete', payload, {
    headers: { 'Content-Type': 'application/json' },
  });

const sendMessageToApplicant = (payload: { text: string; id: number | string }) =>
  api.v1('post', 'tck/bms/incidents/message', payload);

export const incidentsRelated = {
  getList,
  getRelatedAvailable,
  relatedCheck,
  relatedSave,
  relatedDelete,
  sendMessageToApplicant,
};
